import { apiRequest } from './axiosConfig';
import { handleApiError } from '../../utils/errorHandling';

export interface CreditPackage {
  credits: number;
  price: number;
}

export interface CreditPackagesResponse {
  success: boolean;
  packages: CreditPackage[];
  currency: string;
}

export interface CreatePurchaseSessionResponse {
  success: boolean;
  checkout_url: string;
  session_id: string;
}

/**
 * Fetch available credit packages.
 */
export const getCreditPackages = async (): Promise<CreditPackagesResponse> => {
  try {
    const response = await apiRequest.get('users/credit-packages');
    return response as unknown as CreditPackagesResponse;
  } catch (error) {
    throw handleApiError(error, 'クレジットパッケージの取得に失敗しました');
  }
};

/**
 * Create a Stripe Checkout session for credit purchase.
 */
export const createPurchaseSession = async (packageIndex: number): Promise<CreatePurchaseSessionResponse> => {
  try {
    const response = await apiRequest.post('users/credits/purchase', {
      package_index: packageIndex,
    });
    return response as unknown as CreatePurchaseSessionResponse;
  } catch (error) {
    throw handleApiError(error, 'クレジット購入セッションの作成に失敗しました');
  }
};

export interface PurchaseStatusResponse {
  success: boolean;
  status: 'pending' | 'completed' | 'failed' | 'refunded';
  is_pending: boolean;
  credits: number;
}

/**
 * Fetch the status of a credit purchase session.
 * 銀行振込など非同期決済で success 画面に来た際の「入金確認中」表示の出し分けに使う。
 */
export const getPurchaseStatus = async (sessionId: string): Promise<PurchaseStatusResponse> => {
  try {
    return await apiRequest.get<PurchaseStatusResponse>('users/credits/purchase/status', {
      params: { session_id: sessionId },
    });
  } catch (error) {
    throw handleApiError(error, '購入ステータスの取得に失敗しました');
  }
};
